var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.products")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", { staticClass: "choose-type" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.selecttype") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row wrapper" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 row no-margin no-padding" },
                            [
                              _c(
                                "vs-radio",
                                {
                                  staticStyle: { float: "left", padding: "0" },
                                  attrs: {
                                    color: "#A3CA76",
                                    vsValue: "product"
                                  },
                                  model: {
                                    value: _vm.form.typeRadios,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "typeRadios", $$v)
                                    },
                                    expression: "form.typeRadios"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("message.product")))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-check-label",
                              staticStyle: { "margin-left": "25px" }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.selecttype_detail1"))
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 row no-margin no-padding" },
                            [
                              _c(
                                "vs-radio",
                                {
                                  staticStyle: { float: "left", padding: "0" },
                                  attrs: {
                                    color: "#A3CA76",
                                    vsValue: "service"
                                  },
                                  model: {
                                    value: _vm.form.typeRadios,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "typeRadios", $$v)
                                    },
                                    expression: "form.typeRadios"
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("message.service")))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-check-label",
                              staticStyle: { "margin-left": "25px" }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.selecttype_detail2"))
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.form.chooseType == "product"
                  ? _c("div", { staticClass: "section-product" }, [
                      _c("section", { staticClass: "mb-1" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("message.general") }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.productimage"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("file-pond", {
                                        ref: "pond",
                                        attrs: {
                                          server: {
                                            process: _vm.process,
                                            revert: _vm.revert,
                                            restore: _vm.restore,
                                            load: _vm.load,
                                            fetch: _vm.fetch
                                          },
                                          name: "file",
                                          className: "my-pond",
                                          acceptedFileTypes:
                                            "image/jpeg, image/png",
                                          imagePreviewHeight: "240",
                                          imageCropAspectRatio: "1:1",
                                          labelIdle: "อัพโหลดรูปภาพ",
                                          labelTapToUndo: "",
                                          labelTapToCancel: "คลิกเพื่อยกเลิก",
                                          labelFileProcessing: "กำลังอัปโหลด",
                                          labelFileLoading: "กำลังโหลด",
                                          labelFileProcessingComplete: "",
                                          labelButtonRemoveItem: "นำออก",
                                          labelFileProcessingError:
                                            "เกิดข้อผิดพลาด",
                                          labelButtonAbortItemProcessing:
                                            "ยกเลิก"
                                        },
                                        on: { init: _vm.handleFilePondInit }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.productname")) +
                                          " *"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.productName,
                                          expression: "form.productName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: [
                                        {
                                          "is-invalid":
                                            _vm.bindClass.product_name
                                        }
                                      ],
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.form.productName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form,
                                            "productName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    this.getNames.includes(_vm.form.productName)
                                      ? _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.namecannotbeduplicated"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-md-6" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.category"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("selectize", {
                                        attrs: {
                                          options: _vm.form.optionsCat,
                                          multiple: false,
                                          create: true,
                                          placeholder: _vm.$t(
                                            "placeholder.selectorcreate"
                                          ),
                                          default: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.onChangedCat()
                                          }
                                        },
                                        model: {
                                          value: _vm.form.catName,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "catName", $$v)
                                          },
                                          expression: "form.catName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("message.unit")))
                                      ]),
                                      _vm._v(" "),
                                      _c("selectize", {
                                        attrs: {
                                          options: _vm.form.optionsUnit,
                                          multiple: false,
                                          create: true,
                                          placeholder: _vm.$t(
                                            "placeholder.selectorcreate"
                                          ),
                                          default: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.onChangedUnit()
                                          }
                                        },
                                        model: {
                                          value: _vm.form.unit,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "unit", $$v)
                                          },
                                          expression: "form.unit"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("message.pricing") }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-row" },
                              [
                                _vm.form.tempPrices.length == 0
                                  ? [
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group row" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-12" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.price")
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-group"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-prepend"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn dropdown-toggle",
                                                            staticStyle: {
                                                              border:
                                                                "1px solid #ced4da"
                                                            },
                                                            attrs: {
                                                              type: "button",
                                                              "data-toggle":
                                                                "dropdown",
                                                              "aria-haspopup":
                                                                "true",
                                                              "aria-expanded":
                                                                "false"
                                                            }
                                                          },
                                                          [
                                                            _vm.form
                                                              .isFixedPrice
                                                              ? [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.fixedprice"
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            !_vm.form
                                                              .isFixedPrice
                                                              ? [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.variableprice"
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-menu"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.form.isFixedPrice = true
                                                                    _vm.form.textField_ProductPrice = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.fixedprice"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.form.isFixedPrice = false
                                                                    _vm.form.textField_ProductPrice = null
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.variableprice"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .textField_ProductPrice,
                                                          expression:
                                                            "form.textField_ProductPrice"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control text-right text-select-all",
                                                      attrs: {
                                                        disabled: !_vm.form
                                                          .isFixedPrice,
                                                        type: "text"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.form
                                                            .textField_ProductPrice
                                                      },
                                                      on: {
                                                        keypress:
                                                          _vm.numberOnly,
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          _vm.form.textField_ProductPrice = _vm.setToValidNumber(
                                                            _vm.form
                                                              .textField_ProductPrice
                                                          )
                                                        },
                                                        blur: function($event) {
                                                          _vm.form.textField_ProductPrice = _vm.setToCustomDigitsNumber(
                                                            _vm.form
                                                              .textField_ProductPrice
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.form,
                                                            "textField_ProductPrice",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group row" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-12" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.cost")
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.form
                                                          .textField_ProductCost,
                                                      expression:
                                                        "form.textField_ProductCost"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control text-right text-select-all",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.form
                                                        .textField_ProductCost
                                                  },
                                                  on: {
                                                    keypress: _vm.numberOnly,
                                                    keyup: function($event) {
                                                      _vm.form.textField_ProductCost = _vm.setToValidNumber(
                                                        _vm.form
                                                          .textField_ProductCost
                                                      )
                                                    },
                                                    blur: function($event) {
                                                      _vm.form.textField_ProductCost = _vm.setToCustomDigitsNumber(
                                                        _vm.form
                                                          .textField_ProductCost
                                                      )
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.form,
                                                        "textField_ProductCost",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group row" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-12" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.barcode")
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.form.barcode,
                                                      expression: "form.barcode"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control text-select-all",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: _vm.form.barcode
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.form,
                                                        "barcode",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-12" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form-group form-row"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-6" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group row"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-12"
                                                      },
                                                      [
                                                        _c("label", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.sku"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form.stock
                                                                  .sku,
                                                              expression:
                                                                "form.stock.sku"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text"
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.form.stock.sku
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.form.stock,
                                                                "sku",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-6" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group row"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-12"
                                                      },
                                                      [
                                                        _c("label", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.stockcount"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form.stock
                                                                  .count,
                                                              expression:
                                                                "form.stock.count"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control text-right text-select-all",
                                                          attrs: {
                                                            type: "text"
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.form.stock
                                                                .count
                                                          },
                                                          on: {
                                                            keypress:
                                                              _vm.numberOnly,
                                                            keyup: function(
                                                              $event
                                                            ) {
                                                              _vm.form.stock.count = _vm.setToValidNumber(
                                                                _vm.form.stock
                                                                  .count
                                                              )
                                                            },
                                                            blur: function(
                                                              $event
                                                            ) {
                                                              _vm.form.stock.count =
                                                                _vm.form.stock
                                                                  .count > 0
                                                                  ? _vm.setToCustomDigitsNumber(
                                                                      _vm.form
                                                                        .stock
                                                                        .count
                                                                    )
                                                                  : null
                                                            },
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.form.stock,
                                                                "count",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-12 mt-1" }, [
                                  _c("div", { staticClass: "form-group row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-12" },
                                      [
                                        [
                                          _vm.form.prices.length > 0
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-light",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openModalPrices()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.addprices",
                                                          {
                                                            number:
                                                              _vm.form.prices
                                                                .length
                                                          }
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-light",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openModalPrices()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.addmoreprices"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                        ]
                                      ],
                                      2
                                    )
                                  ])
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("app.inventory.title") }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                [
                                  _c("vs-switch", {
                                    staticStyle: {
                                      float: "left",
                                      "margin-right": "10px"
                                    },
                                    attrs: { color: "#A3CA76" },
                                    model: {
                                      value: _vm.form.assign_inventory,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "assign_inventory",
                                          $$v
                                        )
                                      },
                                      expression: "form.assign_inventory"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("message.assignitemto", {
                                          string: _vm.$t("app.inventory.title")
                                        })
                                      ) +
                                      "\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://www.treesoft.io/th/manual/product#item",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("button.learnmore")) + " "
                                      ),
                                      _c("i", {
                                        staticClass: "fas fa-external-link-alt"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("app.pos.title") }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                [
                                  _c("vs-switch", {
                                    staticStyle: {
                                      float: "left",
                                      "margin-right": "10px"
                                    },
                                    attrs: { color: "#A3CA76" },
                                    model: {
                                      value: _vm.form.assign_pos,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "assign_pos", $$v)
                                      },
                                      expression: "form.assign_pos"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("message.assignitemto", {
                                          string: _vm.$t("app.pos.title")
                                        })
                                      ) +
                                      "\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://www.treesoft.io/th/manual/product#item",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("button.learnmore")) + " "
                                      ),
                                      _c("i", {
                                        staticClass: "fas fa-external-link-alt"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.chooseType == "service"
                  ? _c("div", { staticClass: "section-service" }, [
                      _c("section", [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("message.service") }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.productimage"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("file-pond", {
                                        ref: "pond",
                                        attrs: {
                                          server: {
                                            process: _vm.process,
                                            revert: _vm.revert,
                                            restore: _vm.restore,
                                            load: _vm.load,
                                            fetch: _vm.fetch
                                          },
                                          name: "file",
                                          className: "my-pond",
                                          acceptedFileTypes:
                                            "image/jpeg, image/png",
                                          imagePreviewHeight: "240",
                                          imageCropAspectRatio: "1:1",
                                          labelIdle: "อัพโหลดรูปภาพ",
                                          labelTapToUndo: "",
                                          labelTapToCancel: "คลิกเพื่อยกเลิก",
                                          labelFileProcessing: "กำลังอัปโหลด",
                                          labelFileLoading: "กำลังโหลด",
                                          labelFileProcessingComplete: "",
                                          labelButtonRemoveItem: "นำออก",
                                          labelFileProcessingError:
                                            "เกิดข้อผิดพลาด",
                                          labelButtonAbortItemProcessing:
                                            "ยกเลิก"
                                        },
                                        on: { init: _vm.handleFilePondInit }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.servicename")) +
                                          " *"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.productName,
                                          expression: "form.productName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: [
                                        {
                                          "is-invalid":
                                            _vm.bindClass.product_name
                                        }
                                      ],
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.form.productName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form,
                                            "productName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("section", [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("message.pricing") }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-6" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("message.price")))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn dropdown-toggle",
                                              staticStyle: {
                                                border: "1px solid #ced4da"
                                              },
                                              attrs: {
                                                type: "button",
                                                "data-toggle": "dropdown",
                                                "aria-haspopup": "true",
                                                "aria-expanded": "false"
                                              }
                                            },
                                            [
                                              _vm.form.isFixedPrice
                                                ? [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.fixedprice"
                                                          )
                                                        ) +
                                                        "\n                          "
                                                    )
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.form.isFixedPrice
                                                ? [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.variableprice"
                                                          )
                                                        ) +
                                                        "\n                          "
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.isFixedPrice = true
                                                      _vm.form.textField_ServicePrice = 0
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.fixedprice"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.isFixedPrice = false
                                                      _vm.form.textField_ServicePrice = null
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.variableprice"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.form.textField_ServicePrice,
                                            expression:
                                              "form.textField_ServicePrice"
                                          }
                                        ],
                                        staticClass:
                                          "form-control text-right text-select-all",
                                        attrs: {
                                          disabled: !_vm.form.isFixedPrice,
                                          type: "text"
                                        },
                                        domProps: {
                                          value: _vm.form.textField_ServicePrice
                                        },
                                        on: {
                                          keypress: _vm.numberOnly,
                                          keyup: function($event) {
                                            _vm.form.textField_ServicePrice = _vm.setToValidNumber(
                                              _vm.form.textField_ServicePrice
                                            )
                                          },
                                          blur: function($event) {
                                            _vm.form.textField_ServicePrice = _vm.setToCustomDigitsNumber(
                                              _vm.form.textField_ServicePrice
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "textField_ServicePrice",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }, [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("message.cost")))
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.textField_ServiceCost,
                                          expression:
                                            "form.textField_ServiceCost"
                                        }
                                      ],
                                      staticClass:
                                        "form-control text-right text-select-all",
                                      attrs: { type: "text" },
                                      domProps: {
                                        value: _vm.form.textField_ServiceCost
                                      },
                                      on: {
                                        keypress: _vm.numberOnly,
                                        keyup: function($event) {
                                          _vm.form.textField_ServiceCost = _vm.setToValidNumber(
                                            _vm.form.textField_ServiceCost
                                          )
                                        },
                                        blur: function($event) {
                                          _vm.form.textField_ServiceCost = _vm.setToCustomDigitsNumber(
                                            _vm.form.textField_ServiceCost
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form,
                                            "textField_ServiceCost",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: { title: _vm.$t("app.pos.title") }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                [
                                  _c("vs-switch", {
                                    staticStyle: {
                                      float: "left",
                                      "margin-right": "10px"
                                    },
                                    attrs: { color: "#A3CA76" },
                                    model: {
                                      value: _vm.form.assign_pos,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "assign_pos", $$v)
                                      },
                                      expression: "form.assign_pos"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("message.assignitemto", {
                                          string: _vm.$t("app.pos.title")
                                        })
                                      ) +
                                      "\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://www.treesoft.io/th/manual/product#item",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("button.learnmore")) + " "
                                      ),
                                      _c("i", {
                                        staticClass: "fas fa-external-link-alt"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.chooseType !== null
                  ? _c(
                      "section",
                      { staticClass: "action-bar" },
                      [
                        [
                          !_vm.$store.state.app.loading
                            ? _c(
                                "div",
                                { staticClass: "col-md-12 text-right" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-web",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.save({
                                            isCreateAnother: false
                                          })
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("button.save")))]
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "col-md-12 text-right" },
                                [_vm._m(0)]
                              )
                        ]
                      ],
                      2
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "pricesModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "pricesModalTitle",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "pricesModalTitle" }
                    },
                    [_vm._v(_vm._s(_vm.$t("message.addmoreprices")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function($event) {
                          return _vm.cancelPrices()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _vm.form.isShowModalPrices
                      ? _c("attribute", {
                          attrs: {
                            trickReset: _vm.form.trickResetAttribute,
                            validation: _vm.form.trickValidationAttribute,
                            data: _vm.form.attributes,
                            defaultPrices: _vm.form.defaultPrices,
                            page: "new"
                          },
                          on: { data: _vm.submitForm }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "a",
                    {
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        href: "https://www.treesoft.io/th/manual/product#item",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("button.learnmore")) + " "),
                      _c("i", { staticClass: "fas fa-external-link-alt" })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.cancelPrices()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.resetPrices()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.reset")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-web",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.applyPrices()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.apply")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bea83378", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bea83378","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/items/product/New.vue
// module id = null
// module chunks = 